import LoginPage from '../LoginPage';
import AdminPage from '../AdminPage';
import DatabasePage from '../DatabasePage';
import NotFound from '../NotFound';
import AssignResourcesPage from '../AssignResourcesPage';
import NewsPage from '../NewsPage';
import NewsDetailPage from '../NewsDetailPage';
import { InstitutionList } from '../InstitutionList';
import QuotesPage from '../QuotesPage';

const appPages = [
	{
		path: '/',
		title: 'Login',
		element: <LoginPage />,
	},
	{
		path: '/admin',
		title: 'Admin',
		element: <AdminPage />,
	},
	{
		path: '/assign-resources',
		title: 'Assign Resources',
		element: <AssignResourcesPage />,
	},
	{
		path: '/database',
		title: 'Database',
		element: <DatabasePage />,
	},
	{
		path: '/news',
		title: 'News',
		element: <NewsPage />,
	},
	{
		path: '/news/:id',
		title: 'News Detail',
		element: <NewsDetailPage />,
	},
	{
		path: '/institutions',
		title: 'Institutions',
		element: <InstitutionList />,
	},
	{
		path: '/quotes',
		title: 'Quotes',
		element: <QuotesPage />,
	},
	{
		path: '*',
		title: '*',
		element: <NotFound />,
	},
];

export default appPages;
